import Vue from 'vue'
import Vuex from 'vuex'
import store from './store/index.js'

import CartList from './components/Checkout/cart-list.vue'
import CartListItem from './components/Checkout/cart-list-item.vue'
import CartListItemService from './components/Checkout/cart-list-item-service.vue'
import CartPromo from './components/Checkout/cart-promo.vue'
import CheckBoxClub from './components/Checkout/check-box-club.vue'
import OrganizationForm from './components/Checkout/OrganizationForm'
import CartItemQuantity from './components/Checkout/cart-item-quantity.vue'
import SelectPayment from './components/Checkout/select-payment.vue'
import CartAddService from './components/Checkout/cart-add-service.vue'
import CartRegisterUser from './components/Checkout/cart-register-user.vue'
import CartRemont from './components/Checkout/cart-remont.vue'
import CartSearchOrder from './components/Checkout/cart-search-order.vue'
import CartBringToRetail from './components/Checkout/cart-bring-to-retail.vue'
import SelectFirm from './components/Checkout/select-firm'
import CartSumm from './components/Checkout/cart-summ.vue'

import AddressForm from './components/Delivery/address-form.vue'
import DeliveryDatetime from './components/Delivery/delivery-datetime.vue'
import PvzSelect2 from './components/Delivery/pvz-select2.vue'
import CourierSelect from './components/Delivery/courier-select.vue'
import PvzMap2 from './components/Delivery/pvz-map2.vue'
import SelectDelivType from './components/Delivery/select-deliv-type.vue'
import SelectDelivTypeRegions from './components/Delivery/select-deliv-type-regions.vue'
import DeliveryComment from './components/Delivery/delivery-comment.vue'
import DeliveryCalc from './components/Delivery/delivery-calc.vue'

import CartAddButton from './components/cart-add-button.vue'
import CartAddButtonProduct from './components/cart-add-button-product.vue'
import CartAddButtonProductVariant from './components/cart-add-button-product-variant.vue'
import CartAddVariantButton from './components/cart-add-variant-button.vue'
import CartAddDeleteButton from './components/cart-add-delete-button.vue'
import CartAddButtonBundle from './components/cart-add-button-bundle.vue'
import SpinnerButtonSubmit from './components/spinner-button-submit.vue'
import DeliveryAddress from './components/Profile/delivery-address.vue'
import ProductFav from './components/product-fav.vue'
import ProductCompare from './components/product-compare.vue'
import ProductQtyInCart from './components/product-qty-in-cart.vue'
import DropdownElement from './components/dropdown-element.vue'
import ProductBundle from './components/product-bundle.vue'
import CartCounter from './components/cart-counter.vue'
import FavCounter from './components/fav-counter.vue'
import CompareCounter from './components/compare-counter.vue'

import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

import SmSearchButton from '@vendor/smukm/search/vuejs/components/sm-search-button.vue'
import SmSearchMain from '@vendor/smukm/search/vuejs/components/sm-search-main.vue'
import './css/sm-search.min.css'

//import setupInterceptors from '@vendor/smukm/search/vuejs/services/setupInterceptors';
//setupInterceptors(store);

Vue.use(Vuex)

/* класс обертка для событий
   слушаем Evnt.listen('changeOrgType', () => {})
   вызываем Evnt.fire('changeOrgType', 123)
 */
window.Evnt = new class {
    constructor() {
        this.vue = new Vue();
    }
    fire(event, data=null) {
        this.vue.$emit(event, data)
    }
    listen(event, callback) {
        this.vue.$on(event, callback)
    }
};

// форматтер вывода цены
numeral.locale('ru');
Vue.filter("formatCurrency", function (value) {
    return numeral(value).format('0,0[.]00');
});

var app = new Vue({
    store,
    el: '#hc-container',
    components: {
        CartList,
        CartListItem,
        CartListItemService,
        CartPromo,
        CheckBoxClub,
        CartItemQuantity,
        CartAddButton,
        CartAddButtonProduct,
        CartAddButtonProductVariant,
        CartAddVariantButton,
        CartAddDeleteButton,
        CartAddButtonBundle,
        SelectPayment,
        SpinnerButtonSubmit,
        OrganizationForm,
        SelectFirm,
        AddressForm,
        DeliveryDatetime,
        PvzSelect2,
        CourierSelect,
        PvzMap2,
        SelectDelivType,
        SelectDelivTypeRegions,
        DeliveryComment,
        Loading,
        DeliveryAddress,
        ProductFav,
        ProductCompare,
        ProductQtyInCart,
        CartAddService,
        CartRegisterUser,
        CartRemont,
        CartSearchOrder,
        CartBringToRetail,
        DeliveryCalc,
        ProductBundle,
        DropdownElement,
        CartCounter,
        FavCounter,
        CompareCounter,
        CartSumm,
        SmSearchButton,
        SmSearchMain
    },
    created() {
        this.$store.dispatch('setCartItems')
        this.$store.dispatch('setFavCount')

        // forms events listener
        Evnt.listen('formSubmittedEvent', (payload) => {
            this.$store.dispatch('formSubmittedEvent', payload)
        })
    }
})
